/* eslint-disable react/jsx-pascal-case */
import React, { Fragment, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import { loadDocumentScoringGrids, generateScoring } from '../actionCreators';
import { loadDocumentScoringResult } from '../actionCreatorsBeta';
import { loadDimensionPeriods } from 'actions/actionCreators/dictionariesActions';
import DocumentScoringResultComponentBeta from './DocumentScoringResultComponentBeta';
import DocumentScoringGridComponent from './DocumentScoringGridComponent';
import { RightsContext } from 'providers/RightsContext';
import {
  getDocumentScoringGrids,
  getDocumentScoringResult,
  getDimensionPeriods,
  getDocumentScoringGridsLoaded,
  getDocumentScoringResultLoaded
} from '../selectors';
import { Grid } from '@mui/material';

export const DocumentScoringContainerBeta = ({
  actions,
  documentId,
  siteId,
  scoringGrids,
  scoringResult,
  viewScoringHistory,
  dimensionPeriods,
  scoringGridsLoaded,
  scoringResultLoaded,
  isFolder
}) => {
  const [scoringInProgress, setScoringInProgress] = useState(false);

  const rights = useContext(RightsContext);

  useEffect(() => {
    actions.loadDimensionPeriods();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (hasNoRights()) {
      return;
    }

    loadData();
  }, [documentId, siteId, scoringGridsLoaded, scoringResultLoaded, rights]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadData = () => {
    actions.loadDocumentScoringGrids(documentId, siteId);

    if (rights.scoringScoringSummaryRead && isFolder) actions.loadDocumentScoringResult(documentId, siteId);
  };

  const hasNoRights = () => {
    return (
      !rights.scoringScoringSummaryRead &&
      !rights.scoringKoRead &&
      !rights.scoringGridDocumentRead &&
      !rights.scoringGridClientRead &&
      !rights.scoringGridAssetRead
    );
  };

  const generateScoring = async () => {
    if (isFolder) {
      setScoringInProgress(true);
      let event = await actions.generateScoring(documentId, siteId);
      if (event.ok) {
        loadData();
      }
      setScoringInProgress(false);
    }
  };

  return (
    <Fragment>
      {rights.scoringScoringSummaryRead && scoringResultLoaded && isFolder && (
        <DocumentScoringResultComponentBeta
          scoringResult={scoringResult}
          scoringInProgress={scoringInProgress}
          generateScoring={generateScoring}
          viewScoringHistory={viewScoringHistory}
        />
      )}
      <Grid container spacing={1} xs={12}>
        {scoringGridsLoaded &&
          scoringGrids.map(s => (
            <DocumentScoringGridComponent
              key={s.documentScoringGridId}
              documentId={documentId}
              siteId={siteId}
              scoringGrid={s}
              isHistory={false}
              dimensionPeriods={dimensionPeriods}
              rights={rights}
            />
          ))}
      </Grid>
    </Fragment>
  );
};

DocumentScoringContainerBeta.propTypes = {
  actions: PropTypes.object.isRequired,
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  scoringGrids: PropTypes.array,
  scoringResult: PropTypes.object.isRequired,
  dimensionPeriods: PropTypes.array.isRequired,
  scoringGridsLoaded: PropTypes.bool.isRequired,
  scoringResultLoaded: PropTypes.bool.isRequired,
  viewScoringHistory: PropTypes.func.isRequired,
  isFolder: PropTypes.bool.isRequired
};

function mapStateToProps(state, route) {
  const key = `${route.documentId}-${route.siteId}`;
  return {
    scoringGrids: getDocumentScoringGrids(state, key),
    scoringGridsLoaded: getDocumentScoringGridsLoaded(state, key),
    scoringResult: getDocumentScoringResult(state, key),
    scoringResultLoaded: getDocumentScoringResultLoaded(state, key),
    dimensionPeriods: getDimensionPeriods(state, key)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadDocumentScoringGrids, generateScoring, loadDocumentScoringResult, loadDimensionPeriods }, dispatch),
    dispatch
  };
}

export default withRouter(compose(connect(mapStateToProps, mapDispatchToProps))(DocumentScoringContainerBeta));
